import api from './client';

export const rejectionReasonAPI = {
  getAllRejectionReasons: async () => {
    const response = await api.get("/rejection-reasons");
    return response.data;
  },

  getRejectionReasonById: async (id) => {
    const response = await api.get(`/rejection-reasons/${id}`);
    return response.data;
  },

  createRejectionReason: async (reasonData) => {
    const response = await api.post("/rejection-reasons", reasonData);
    return response.data;
  },

  updateRejectionReason: async (id, reasonData) => {
    const response = await api.put(`/rejection-reasons/${id}`, reasonData);
    return response.data;
  },

  deleteRejectionReason: async (id) => {
    const response = await api.delete(`/rejection-reasons/${id}`);
    return response.data;
  },

  getRejectionReasonsByCategory: async (category) => {
    const response = await api.get(`/rejection-reasons/category/${category}`);
    return response.data;
  },

  getActiveReasons: async () => {
    const response = await api.get("/active-rejection-reasons");
    return response.data;
  },

  toggleActive: async (id) => {
    const response = await api.patch(`/rejection-reasons/${id}/toggle-active`);
    return response.data;
  },

  getByCategory: async (category) => {
    const response = await api.get(`/rejection-reasons/category/${category}`);
    return response.data;
  },
};

// Employer Sync API (ECLAB Integration)
